import classnames from 'classnames';
import { useEffect, useMemo, useState } from 'react';
import { CollapseType } from '@meitu/saas-editor-ui/es/types';
import { useLockAppData } from '@/hooks';
import { useCollapseModel } from '@/store/collapse-models/collapse-model';
import { useEditorModel } from '@/store/models/editor-model';
import { collapseBackgroundConf, collapseConf, defaultCollapse, refreshCollapseConf } from './config';
import './index.less';

const Collapse = () => {
    const currentType = useCollapseModel((state) => state.currentType);
    const actualType = useCollapseModel((state) => state.actualType);
    const isDisableAppAndShowPanel = useEditorModel((state) => state.isDisableAppAndShowPanel);
    const renderType = actualType || currentType;

    const lockApp = useLockAppData();
    // const disableApp = useDisableAppData();
    // 默认加载导航栏
    const [cacheCollapseType, setCacheCollapseType] = useState<string[]>([...defaultCollapse]);

    const lockClassName = useMemo(() => {
        return currentType !== CollapseType.MINE_MENU ? lockApp : '';
    }, [currentType, lockApp]);

    /**
     * 缓存当前打开的面板类型
     */
    useEffect(() => {
        if (!renderType || cacheCollapseType.includes(renderType)) return;
        setCacheCollapseType((prev) => [...prev, renderType]);
    }, [renderType]);

    return (
        <div className={classnames('p-collapse', isDisableAppAndShowPanel ? 'c-disable-app' : '')}>
            {!renderType ? (
                <div className={classnames('p-collapse__container', lockClassName)} />
            ) : (
                <>
                    {Object.keys(refreshCollapseConf).map((key) => {
                        const isActive = key === renderType;
                        return isActive ? (
                            <div
                                key={key}
                                className={classnames('p-collapse__container', lockClassName, key, {
                                    'p-collapse__container-secondary': collapseBackgroundConf[key] === 'secondary',
                                })}
                                style={{ display: 'block' }}
                            >
                                {refreshCollapseConf[key]}
                            </div>
                        ) : null;
                    })}

                    {Object.keys(collapseConf).map((key) => {
                        const isActive = key === renderType;
                        return (
                            <div
                                key={key}
                                className={classnames('p-collapse__container', lockClassName, key, {
                                    'p-collapse__container-secondary': collapseBackgroundConf[key] === 'secondary',
                                })}
                                style={
                                    isActive
                                        ? {}
                                        : // 画布预览图不能用'display: none;', 否则domToImage生成图片会有问题
                                          key === CollapseType.NAVIGATOR_MENU
                                          ? {
                                                height: 0,
                                                padding: 0,
                                                overflow: 'hidden',
                                            }
                                          : { display: 'none' }
                                }
                            >
                                {cacheCollapseType.includes(key) ? collapseConf[key] : null}
                            </div>
                        );
                    })}
                </>
            )}
        </div>
    );
};

export default Collapse;
